/* global axios */

import ApiClient from './ApiClient';

class CurrentAgentPause extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  get() {
    return axios.get(`${this.baseUrl()}/current_agent_pause`);
  }

  create(pauseTemplateId) {
    return axios.post(`${this.baseUrl()}/current_agent_pause`, {
      pause_template_id: pauseTemplateId,
    });
  }

  delete() {
    return axios.delete(`${this.baseUrl()}/current_agent_pause`);
  }
}

export default new CurrentAgentPause();
